import { opacifyHex } from '@myre/common-primitives';
import { COLOR_NEUTRAL_NINE } from '@myre/common-styles';

import { type ChartDataset } from 'chart.js';

import { type ChartType } from './enums';

export function defaultDatasetBarStyle(
  color: string,
): Partial<ChartDataset<ChartType.Bar>> {
  return {
    backgroundColor: opacifyHex(color, 0.6),
    borderColor: opacifyHex(color, 1),
    borderWidth: 1,
    // Bar width
    barThickness: 24,
    hoverBackgroundColor: opacifyHex(color, 1),
    hoverBorderColor: COLOR_NEUTRAL_NINE,
  };
}

export function defaultDatasetLineStyle(
  color: string,
): Partial<ChartDataset<ChartType.Line>> {
  return {
    // Removing points on the line (only the line is desired)
    pointStyle: false,
    borderColor: opacifyHex(color, 1),
    borderWidth: 1,
    borderDash: [5, 5],
  };
}
